module.exports = __webpack_public_path__ + "static/images/discover.3b2xxPH.svg";